import { useState, useEffect, useRef } from 'react' 
import { useSelector } from 'react-redux'
import YzBackgroundMobile from '../../../../../components/mobile/YzBackgroundMobile'
import WebNavigationMainMobile from '../WebNavigationMainMobile'
import FooterMobile from '../../../../../components/mobile/FooterMobile'
import BuoyBoxMobile from '../../../../../components/mobile/BuoyBoxMobile'
import './index.less'

const WebNavigationSectionMobile = () => {
  // 菜单
  const menuList = useSelector((state) => state?.Menu?.menuList) // 菜单列表
  const [backgroud] = menuList.filter(f => f.title === '网址导航').map(m => m.backgroud)

  // 置顶
  const boxRef = useRef(null)
  const [scrollTop, setScrollTop] = useState(0)
  const [clientHeight, setClientHeight] = useState(0)
  const goToTop = () => { // 置顶事件
    let myTimer = setInterval(() => {
      boxRef.current.scrollTop -= 60
      if(boxRef.current.scrollTop<=0){
        boxRef.current.scrollTop = 0
        window.clearInterval(myTimer)
      }
    }, 10)
  }
  useEffect(() => { // 页面滚动
    window.addEventListener('scroll', (e) => {
      setScrollTop(e?.target?.scrollTop)
      setClientHeight(e?.target?.clientHeight);
    }, true)
  }, [])

  return (
    <section ref={boxRef} className='web_navigation_section_m'>
      <div className='web_navigation_section_m_box'>
        <YzBackgroundMobile
          title='分享有价值的资源导航'
          content={`汇集优质的软件工具，学习资源，网站导航`}
          backgroundImage={backgroud}
          isShowButton={false}
        />
        <WebNavigationMainMobile />
        <FooterMobile isAbout={false} />
        <BuoyBoxMobile isShowTop={scrollTop > clientHeight} onTop={goToTop} />
      </div>
    </section>
  )
}

export default WebNavigationSectionMobile